(function () {
  if (window.Shopify && Shopify.designMode) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Section reveal-on-scroll ---------- */

  if ('IntersectionObserver' in window && !reduceMotion) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    var revealSection = function (section, index) {
      if (section.hasAttribute('data-scroll-reveal')) return;
      section.setAttribute('data-scroll-reveal', '');
      section.style.transitionDelay = (index % 4) * 0.12 + 's';
      revealObserver.observe(section);
    };

    var scanReveal = function (root) {
      (root || document).querySelectorAll('main > .shopify-section').forEach(revealSection);
    };

    scanReveal();
    document.addEventListener('shopify:section:load', function (event) {
      scanReveal(event.target.parentElement || document);
    });
  }

  /* ---------- Continuous background parallax ---------- */

  if (reduceMotion) return;

  var PARALLAX_STRENGTH = 0.18; // fraction of scroll distance the layer lags/leads by
  var layers = [];

  function isFullBleedMedia(el) {
    if (el.tagName !== 'IMG' && el.tagName !== 'VIDEO') return false;
    var style = getComputedStyle(el);
    if (style.position !== 'absolute' && style.position !== 'fixed') return false;
    var parent = el.offsetParent;
    if (!parent) return false;
    var rect = el.getBoundingClientRect();
    var parentRect = parent.getBoundingClientRect();
    if (parentRect.width === 0 || parentRect.height === 0) return false;
    var coversWidth = rect.width / parentRect.width > 0.85;
    var coversHeight = rect.height / parentRect.height > 0.6;
    return coversWidth && coversHeight;
  }

  function findLayers(root) {
    var candidates = (root || document).querySelectorAll('main img, main video');
    candidates.forEach(function (el) {
      if (el.hasAttribute('data-parallax-layer')) return;
      if (!isFullBleedMedia(el)) return;
      el.setAttribute('data-parallax-layer', '');
      layers.push(el);
    });
  }

  var ticking = false;

  function updateLayers() {
    ticking = false;
    var viewportHeight = window.innerHeight;
    var viewportCenter = viewportHeight / 2;

    layers.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > viewportHeight + 200) return; // skip off-screen work
      var elementCenter = rect.top + rect.height / 2;
      var distanceFromCenter = elementCenter - viewportCenter;
      var offset = distanceFromCenter * PARALLAX_STRENGTH * -1;
      el.style.setProperty('--parallax-offset', offset.toFixed(1) + 'px');
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateLayers);
  }

  findLayers();
  updateLayers();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    findLayers(event.target.parentElement || document);
    updateLayers();
  });
})();
